import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';

/**
 * PublicPageHeader - A minimal header for public-facing pages (Help, FAQ, Contact, etc.)
 * Provides back navigation to satisfy mobile UX requirements and Play Store review criteria.
 */
const PublicPageHeader = ({ title }) => {
  const navigate = useNavigate();

  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        minHeight: 56,
      }}
    >
      <IconButton
        aria-label="Go back"
        onClick={() => navigate(-1)}
        sx={{ 
          minWidth: 48, 
          minHeight: 48,
          padding: '12px',
          marginLeft: '8px',
          '& .MuiSvgIcon-root': {
            fontSize: '24px'
          }
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      <Typography 
        variant="h6" 
        component="h1" 
        sx={{ 
          flex: 1, 
          fontWeight: 600, 
          fontSize: { xs: '0.9rem', sm: '1rem' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: 'calc(100% - 120px)'
        }}
      >
        {title}
      </Typography>
      <IconButton
        aria-label="Go to home"
        onClick={() => navigate('/')}
        sx={{ 
          minWidth: 48, 
          minHeight: 48,
          padding: '12px',
          '& .MuiSvgIcon-root': {
            fontSize: '24px'
          }
        }}
      >
        <HomeIcon />
      </IconButton>
    </Box>
  );
};

export default PublicPageHeader;
